import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";

import { Auth } from "@inflo/shared/auth";

import AuthComponent from "./Auth";

const rootElement = document.getElementById("container1");
const root = createRoot(rootElement);

/* Render application after Office initializes */
Office.onReady(() =>
  root.render(
    <AuthProvider userManager={Auth.infloUserManager}>
      <AuthComponent />
    </AuthProvider>
  )
);

if (module.hot) {
  module.hot.accept("./Auth", () => {
    root.render(
      <AuthProvider userManager={Auth.infloUserManager}>
        <AuthComponent />
      </AuthProvider>
    );
  });
}
